module.exports = __webpack_public_path__ + "static/logo-base-80f2a0931f5104ee36a011ab7c90ef18.png";